export type Gender = "男" | "女";

export interface Actor {
  id: string;
  name: string;
  avatar: string;
  gender: Gender;
  region: string;
  birth: string;
  popularity: number;
  works: string[];
  representative: string;
  bio: string;
}

export const actors: Actor[] = [
  {
    id: "a1",
    name: "林知遥",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20an%20elegant%20Chinese%20actress%20with%20long%20dark%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a1&orientation=squarish",
    gender: "女",
    region: "中国大陆",
    birth: "1994年3月",
    popularity: 95,
    works: ["f1", "f7", "f10", "f15"],
    representative: "《长夜将明》《风声再起》",
    bio:
      "毕业于中央戏剧学院表演系，早期以舞台剧积累扎实功底，2018 年凭《长夜将明》中的记者一角获得广泛关注。她擅长塑造内心层次丰富的女性角色，被媒体称为“最具韧性的年轻演员”之一。此后陆续出演《回到1999》《风声再起》等作品，戏路横跨年代、悬疑与都市题材。",
  },
  {
    id: "a2",
    name: "沈亦舟",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20calm%20Chinese%20actor%20with%20short%20dark%20hair%20and%20light%20stubble%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a2&orientation=squarish",
    gender: "男",
    region: "中国大陆",
    birth: "1990年7月",
    popularity: 92,
    works: ["f1", "f3", "f6", "f13"],
    representative: "《山与海之间》《长夜将明》",
    bio:
      "以细腻克制的表演风格著称，出道十余年始终活跃在影视一线。既能驾驭《山与海之间》中内敛深情的建筑师，也能在《星轨之外》里诠释孤独的宇航员。他本人极少接受采访，却总能让角色替自己说话。",
  },
  {
    id: "a3",
    name: "苏晚晴",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20fashionable%20Hong%20Kong%20actress%20with%20wavy%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a3&orientation=squarish",
    gender: "女",
    region: "中国香港",
    birth: "1992年11月",
    popularity: 80,
    works: ["f2", "f4", "f11"],
    representative: "《都市迷情》《雾港迷航》",
    bio:
      "出身香港演艺世家，早年以模特身份入行，后转型演员。她身上兼具都市感与烟火气，在《都市迷情》《雾港迷航》中塑造的女性形象鲜活而有力量，近年也活跃于综艺与纪录片领域。",
  },
  {
    id: "a4",
    name: "陆沉",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20stoic%20Chinese%20actor%20with%20sharp%20features%20and%20neat%20dark%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20dramatic%20warm%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a4&orientation=squarish",
    gender: "男",
    region: "中国大陆",
    birth: "1988年1月",
    popularity: 93,
    works: ["f2", "f8", "f10", "f15"],
    representative: "《风声再起》《雾港迷航》",
    bio:
      "厚积薄发的实力派演员，早年深耕话剧舞台。他善于在沉默中传达张力，无论是《风声再起》里深藏不露的特工，还是《刃》中孤注一掷的拳手，都让观众印象深刻。业内外公认的“角色变色龙”。",
  },
  {
    id: "a5",
    name: "高桥美纪",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20gentle%20Japanese%20actress%20with%20soft%20fringe%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a5&orientation=squarish",
    gender: "女",
    region: "日本",
    birth: "1995年6月",
    popularity: 76,
    works: ["f9", "f12", "f14"],
    representative: "《樱花落时》《午夜书店》",
    bio:
      "日本新生代女演员，气质清新而富有故事感。凭晨间剧崭露头角后，先后出演《樱花落时》《午夜书店》等治愈系作品，也尝试了《深海回声》中的硬朗科研角色，展现出令人惊喜的可塑性。",
  },
  {
    id: "a6",
    name: "金志勋",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20an%20athletic%20Korean%20actor%20with%20short%20dark%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a6&orientation=squarish",
    gender: "男",
    region: "韩国",
    birth: "1991年9月",
    popularity: 84,
    works: ["f8", "f9", "f15"],
    representative: "《刃》",
    bio:
      "以动作戏见长的韩国演员，曾接受多年武术训练。《刃》中的高难度打斗几乎全部亲身上阵，被观众称为“行走的动作美学”。私下却以温柔幽默圈粉，反差感十足。",
  },
  {
    id: "a7",
    name: "顾星辰",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20youthful%20Chinese%20actor%20with%20tousled%20dark%20hair%20and%20bright%20eyes%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a7&orientation=squarish",
    gender: "男",
    region: "中国大陆",
    birth: "1996年5月",
    popularity: 88,
    works: ["f1", "f3", "f5", "f7", "f13"],
    representative: "《少年游》《回到1999》",
    bio:
      "新生代人气演员，从《少年游》的少年剑客一炮而红。他表演松弛自然，擅长刻画成长中的迷茫与倔强，在综艺《笑傲江湖会》中也展现了不俗的临场反应力，是当下最受年轻观众关注的面孔之一。",
  },
  {
    id: "a8",
    name: "何静姝",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20warm%20smiling%20Chinese%20actress%20with%20tied%20up%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a8&orientation=squarish",
    gender: "女",
    region: "中国大陆",
    birth: "1993年12月",
    popularity: 82,
    works: ["f2", "f3", "f7", "f11"],
    representative: "《山与海之间》《回到1999》",
    bio:
      "科班出身的她以自然真挚的表演打动观众，尤其擅长生活流角色。《山与海之间》中坚韧的姐姐、《向往的厨房》里手巧的主厨，都让人感到亲切。她也长期参与公益短片创作。",
  },
  {
    id: "a9",
    name: "沈墨白",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20mature%20Hong%20Kong%20actor%20with%20slicked%20back%20dark%20hair%20and%20suit%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20dramatic%20warm%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a9&orientation=squarish",
    gender: "男",
    region: "中国香港",
    birth: "1987年4月",
    popularity: 79,
    works: ["f4", "f10", "f14"],
    representative: "《都市迷情》《风声再起》",
    bio:
      "香港实力派男演员，纵横影坛近二十年。他身上自带一种亦正亦邪的复杂气质，在《风声再起》中饰演的对手戏角色层层反转，令观众拍案叫绝，被评价为“一出场就有戏”。",
  },
  {
    id: "a10",
    name: "艾米莉·卡特",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20photograph%20of%20a%20confident%20western%20actress%20with%20short%20blonde%20hair%2C%20soft%20light%20gray%20studio%20background%2C%20modern%20editorial%20headshot%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20high%20detail%2C%20clean%20minimal%20aesthetic&width=480&height=480&seq=actor-a10&orientation=squarish",
    gender: "女",
    region: "美国",
    birth: "1989年8月",
    popularity: 86,
    works: ["f6", "f12"],
    representative: "《星轨之外》",
    bio:
      "好莱坞实力派女演员，以硬朗与细腻并存的气质著称。她在《星轨之外》中饰演的领航员兼具理智与脆弱，成为影片的灵魂所在；在《深海回声》里则化身冷静的海底工程师，再度刷新观众认知。",
  },
];